import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type MyLawyerInformationQueryVariables = Types.Exact<{ [key: string]: never }>

export type MyLawyerInformationQuery = {
  __typename?: 'Query'
  myLawyerInformation: {
    __typename?: 'Lawyer'
    qlikAppId?: string | null
    qlikSheetId?: string | null
  }
}

export const MyLawyerInformationDocument = gql`
  query MyLawyerInformation {
    myLawyerInformation {
      qlikAppId
      qlikSheetId
    }
  }
`
export function useMyLawyerInformationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MyLawyerInformationQuery,
    MyLawyerInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<MyLawyerInformationQuery, MyLawyerInformationQueryVariables>(
    MyLawyerInformationDocument,
    options
  )
}
export function useMyLawyerInformationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MyLawyerInformationQuery,
    MyLawyerInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<MyLawyerInformationQuery, MyLawyerInformationQueryVariables>(
    MyLawyerInformationDocument,
    options
  )
}
export type MyLawyerInformationQueryHookResult = ReturnType<typeof useMyLawyerInformationQuery>
export type MyLawyerInformationLazyQueryHookResult = ReturnType<
  typeof useMyLawyerInformationLazyQuery
>
export type MyLawyerInformationQueryResult = ApolloReactCommon.QueryResult<
  MyLawyerInformationQuery,
  MyLawyerInformationQueryVariables
>
export function refetchMyLawyerInformationQuery(variables?: MyLawyerInformationQueryVariables) {
  return { query: MyLawyerInformationDocument, variables: variables }
}
